import ColoringGrid from "./ColoringGrid";

export default function GameBoard() {
  return (
    <div className="game-board">
      <ColoringGrid />
    </div>
  );
}
